import { AxiosInstance } from "../../axios/axiosInstance"
import { apiRoutes } from "../../utils/ApiRoutes";
import { IAuthData, IForgotPasswordData, IResetPasswordData } from "./IApisInterface";

export const registerApi = async (payload: IAuthData) => {
    const response = await AxiosInstance.post(
        apiRoutes?.register,
        payload
    );
    return response
}

export const loginApi = async (payload: IAuthData) => {
    const response = await AxiosInstance.post(
        apiRoutes?.login,
        payload
    )
    return response
}

export const adminLoginApi = async (payload: IAuthData) => {
    const response = await AxiosInstance.post(apiRoutes?.adminLogin, payload)
    return response
}

export const forgotPasswordApi = async (payload: IForgotPasswordData) => {
    const response = await AxiosInstance.post(apiRoutes?.forgotpassword, payload)
    return response
}

export const resetPasswordApi = async (payload: IResetPasswordData) => {
    const response = await AxiosInstance.post(apiRoutes?.resetPassword, payload)
    return response
}
export const resetEmployeePasswordApi = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.resetEmployeepassword, payload)
    return response
}

export const getCurrentUserApi = async (domain: string, skipAuth?: boolean) => {
    const headers = skipAuth ? { skipAuth: "true" } : undefined;
    const response = await AxiosInstance.post(
        apiRoutes?.currentuser, { domain }, { headers }
    );
    return response
}

export const bridgeExchangeTokenApi = async (bridge_token: string, workspaceId: string) => {
    const response = await AxiosInstance.post(
        apiRoutes?.bridgeExchangeToken, { bridge_token, workspaceId }
    );
    return response
}

export const authAppleExchangeTokenApi = async (bridge_token: string) => {
    const response = await AxiosInstance.post(
        apiRoutes?.authAppleExchangeToken, { bridge_token }
    );
    return response
}

export const exchangeGBPTokenApi = async (bridge_token: string, token_data: string, workspaceId: string) => {
    const response = await AxiosInstance.post(
        apiRoutes?.exchangeGBPToken, { bridge_token, token_data, workspaceId }
    );
    return response
}
export const exchangeGBPFetchTokenApi = async (bridge_token: string, code: string, workspaceId: string) => {
    const response = await AxiosInstance.post(
        apiRoutes?.exchangeGBPFetchToken, { bridge_token, code, workspaceId }
    );
    return response
}

export const exchangeReconnectGBPTokenApi = async (bridge_token: string, code: string, workspaceId: string) => {
    const response = await AxiosInstance.post(
        apiRoutes?.exchangeReconnectGBPToken, { bridge_token, code, workspaceId }
    );
    return response
}


export const reconnectGBPPlatformApi = async (payload: any) => {
    const response = await AxiosInstance.post(
        apiRoutes?.reconnectGBPPlatform,
        payload
    );
    return response
}

export const adminUserBypassApi = async (userId: string, workspaceId?: string) => {
    const payload: { userId: string; workspaceId?: string } = { userId };
    if (workspaceId) {
        payload.workspaceId = workspaceId;
    }
    const response = await AxiosInstance.post(apiRoutes?.adminUserBypass, payload);
    return response;
}
export const checkUserExistsApi = async (token: string) => {
    const response = await AxiosInstance.post(apiRoutes?.checkUserExists, { token });
    return response.data;
}
